var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{on:{"click":function($event){return _vm.$router.push('/')}}},[_c('b-avatar',{attrs:{"src":"/auth-logo.png","size":"5rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }